import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import {
  Typography,
  Skeleton,
} from '@beeline/design-system-react/extracted-styles';

import { WidgetsGrid } from './WidgetsGrid';
import styles from './styles.module.scss';
import { useWidgetsApi } from './useWidgetsApi';

export function Widgets(): ReactElement {
  const { employeeNumber } = useParams();
  const { isLoading } = useWidgetsApi(employeeNumber);

  return (
    <div className={styles.subgrid}>
      {isLoading ? (
        <Skeleton
          variant='line'
          width={96}
          height={22}
          className={styles.title}
        />
      ) : (
        <Typography variant='h5' className={styles.title}>
          События
        </Typography>
      )}

      <WidgetsGrid />
    </div>
  );
}
